<template>
  <div>
    <dw-survey-dcs-wrapper :id="id" is-answer-submit="true" @getDate="setDate" >
      <template v-slot:dw-dcs-main-slot="{survey}" >
        <div class="dw-dcs-main-title">
          <el-row type="flex">
            <el-col :span="18"><div style="font-size: 14px;padding: 10px;"><strong>未提交名单</strong></div></el-col>
            <el-col :span="6" style="text-align: right;padding-right: 16px;" ><el-button type="primary" size="small" @click="handleExport" >导出数据</el-button></el-col>
          </el-row>
        </div>
        <el-table
          :data="tableData"
          stripe
          style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="姓名" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.stuName" ></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.stuName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="学号" >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.stuNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="班级" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.className" ></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.className"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="指导教师" >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.schoolTea }}</span>
            </template>
          </el-table-column>
          <el-table-column label="教师工号" >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.teacherNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实习计划" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p v-html="scope.row.planName" ></p>
                <div slot="reference" class="name-wrapper">
                  <div v-html="scope.row.planName"></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="dw-pagination">
          <el-pagination
            :page-size="pageSize"
            :current-page="currentPage"
            :total="total"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </template>
    </dw-survey-dcs-wrapper>
    <el-dialog :visible.sync="dialogFormVisible" append-to-body title="导出数据" width="40%" >
      <div style="line-height: 30px;">导出文件将在后台异步进行,确定后请在《导出管理》中查询文件生成结果</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="executeExportData">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import DwSurveyDcsWrapper from '@/components/common/DwSurveyDcsWrapper'
import {surveyAnswerUnSubmit, dwSurveyUnSubmitExport} from '@/api/dw-survey'
export default {
  name: 'DwSurveyAnswerUnSubmit',
  components: {
    DwSurveyDcsWrapper
  },
  data () {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      surveyId: '',
      startTime: '',
      endTime: '',
      planId: '',
      dialogFormVisible: false
    }
  },
  mounted () {
    this.surveyId= this.$route.params.id
  },
  methods: {
    setDate (val, planId) {
      this.startTime=val[0]
      this.endTime=val[1]
      this.planId =planId
      this.queryList(1)
    },
    handleGo: function (url) {
      window.open('https://qiniuexport.gongxueyun.com/'+url, '_blank')
    },
    handleCurrentChange (val) {
      this.queryList(val)
    },
    handleExport () {
      this.dialogFormVisible = true
    },
    executeExportData () {
      dwSurveyUnSubmitExport(this.surveyId, this.startTime, this.endTime, this.planId).then((response) => {
        console.log(response)
        const httpResult = response.data
        if (httpResult.resultCode === 200) {
          this.$message.success(httpResult.data)
        } else {
          this.$message.error('导出失败')
        }
      })
      this.dialogFormVisible = false
    },
    queryList (pageNo) {
      surveyAnswerUnSubmit(this.surveyId, this.startTime, this.endTime, this.planId, this.pageSize, pageNo).then((response) => {
        const resultData = response.data
        if (resultData) {
          this.tableData = resultData.data
          this.total = resultData.total
          this.currentPage = resultData.current
          this.pageSize = resultData.pageSize
        }
      })
    }
  }
}

</script>
<style scoped>
.dw-pagination{
  padding-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-survey/dw-data/DwSurveyAnswerUnSubmit.vue